// src/components/RequireAuth.jsx
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import {
    isAuthenticated,
    getActiveRole,
    getRoles,
    shouldPromptRole,
    targetPathForRole,
} from '../utils/auth';

const RequireAuth = ({ allowedRoles, children }) => {
    const location = useLocation();
    const pathname = (location?.pathname || '').replace(/\/+$/, '') || '/';

    // 1) Must be logged in
    if (!isAuthenticated()) {
        return <Navigate to="/login" replace state={{ from: location }} />;
    }

    // 2) Let the role picker render freely (no role checks here)
    if (pathname === '/select-role') {
        return children;
    }

    // 3) If user must pick a role, send them to the picker
    if (shouldPromptRole()) {
        return <Navigate to="/select-role" replace />;
    }

    // 4) If this route restricts roles, ensure activeRole matches
    if (Array.isArray(allowedRoles) && allowedRoles.length > 0) {
        const activeRole = getActiveRole();
        const allowed = allowedRoles.map(r => String(r).toUpperCase());

        if (!activeRole || !allowed.includes(activeRole)) {
            const roles = getRoles();

            // If user still needs to choose (multi-role & no active), go to picker
            if (roles.length > 1) {
                return <Navigate to="/select-role" replace />;
            }

            // Otherwise, send to home based on first known role
            const role = activeRole || roles[0] || '';
            return <Navigate to={targetPathForRole(role)} replace />;
        }
    }

    // 5) All good — render the protected content
    return children;
};

export default RequireAuth;
